import { NavLink } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import theme from "@/theme";
import SettingsSvg from "@/assets/svg/SettingsSvg";
import LogoutSvg from "@/assets/svg/LogoutSvg";
import { books } from "@/assets/books";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { logout } from "@/store/slice/authSlice";
import { styles } from "../stylesSidebar";
import { Typography } from "@mui/material";
import { walletApi } from "@/store/api/walletApi";
import { conversationsApi } from "@/store/api/conversationsApi";
import { useLogoutUserMutation } from "@/store/api/authApi";

const bottomMenuItems = [
  { text: "Settings", icon: <SettingsSvg />, link: "/settings/account" },
  { text: "Logout", icon: <LogoutSvg />, link: books.login },
];

interface SidebarBottomMenuProps {
  onItemClick?: () => void;
}

const SidebarBottomMenu = ({ onItemClick }: SidebarBottomMenuProps) => {
  const dispatch = useAppDispatch();
  const [logoutUser] = useLogoutUserMutation();
  // const location = useLocation();
  // const pathWithoutLeadingSlash =
  //   location.pathname.startsWith("/") && location.pathname.length > 1
  //     ? location.pathname.substring(1)
  //     : location.pathname;

  const logoutSite = (item: string) => {
    if (item === books.login) {
      logoutUser()
        .unwrap()
        .catch((error) => console.error("Failed to logout:", error))
        .finally(() => {
          dispatch(logout());
          dispatch(walletApi.util.resetApiState());
          dispatch(conversationsApi.util.resetApiState());
          localStorage.clear();
        });
    }
    onItemClick?.();
  };

  return (
    <Box
      sx={{
        margin: "0 auto",
        maxWidth: "12rem",
        padding: "0",
      }}
    >
      <List sx={{ width: "100%" }}>
        {bottomMenuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <NavLink
              to={item.link}
              onClick={() => logoutSite(item.link)}
              style={({ isActive }) => ({
                textDecoration: "none",
                color: isActive ? theme.palette.custom.mainBlue : theme.palette.custom.blueGray900,
                backgroundColor: "#f4f5f6",
                borderRadius: "0.5rem",
                width: "inherit",
              })}
            >
              <ListItemButton>
                {/* <ListItemIcon sx={styles.listItemIcon(pathWithoutLeadingSlash, item.link)}>
                  {item.icon}
                </ListItemIcon> */}
                <ListItemText
                  primary={<Typography sx={styles.listItemText}>{item.text}</Typography>}
                />
              </ListItemButton>
            </NavLink>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default SidebarBottomMenu;
